import { Description } from 'all-in-one-shared-api';
import { CHINESE_SYMBOL } from 'i18n';

export const getTextByLocale = (i18n: string, text: Description | undefined): string => {
  if (text) {
    return i18n === CHINESE_SYMBOL ? text.chineseDescription ?? '' : text.description ?? '';
  }
  return '';
};
